import type { ProductPublicDto } from "@sticker-giant/sg-frontend-common";

export interface ProductDataMismatch {
  label: string;
  defaultValue: string;
  availableSkus: string[];
}

interface FieldCheck {
  label: string;
  defaultValue: string | null | undefined;
  options: { sku: string }[] | undefined;
}

export function findProductDataMismatches(productAdmin: ProductPublicDto): ProductDataMismatch[] {
  const checks: FieldCheck[] = [
    { label: "defaultShape", defaultValue: productAdmin.defaultShape, options: productAdmin.shapeOptions },
    { label: "defaultMaterial", defaultValue: productAdmin.defaultMaterial, options: productAdmin.materialOptions },
    { label: "defaultLaminate", defaultValue: productAdmin.defaultLaminate, options: productAdmin.laminateOptions },
    { label: "defaultFinishing", defaultValue: productAdmin.defaultFinishing, options: productAdmin.finishingOptions },
    { label: "defaultAdhesive", defaultValue: productAdmin.defaultAdhesive, options: productAdmin.adhesiveOptions },
    {
      label: "defaultOrientation",
      defaultValue: productAdmin.defaultOrientation,
      options: productAdmin.orientationOptions,
    },
  ];

  const mismatches: ProductDataMismatch[] = [];
  for (const { label, defaultValue, options } of checks) {
    if (!defaultValue) continue;
    if (!options || options.length === 0) continue;
    if (options.some(option => option.sku === defaultValue)) continue;
    mismatches.push({
      label,
      defaultValue,
      availableSkus: options.map(option => option.sku),
    });
  }
  return mismatches;
}
